import API from "../../api";
export default class ApplicationPreference {
  /**
   * The Instrument dimension table for M3
   * @param {string} UserEmail
   * @param {bool} ReceiveEmailNotifications
   * @param {bool} ShowWorkRequestsWidget
   * @param {bool} ShowRecentSamplesWidget
   * @param {bool} ShowRecentTestsWidget
   * @param {bool} ShowRecentBlendsWidget
   * @param {DateTime} LastLogin
   * @param {string} HomeSiteName
   * @param {List<Project>} MemberProjects
   * @param {bool} receiveDailyUpdate
   * @param {bool} isSampleRetainMetadata
   */
  constructor({
    userEmail,
    receiveEmailNotifications,
    showWorkRequestWidget,
    showRecentSamplesWidget,
    showRecentTestsWidget,
    showRecentBlendsWidget,
    lastLogin,
    homeSiteName,
    homeSite,
    memberProjects,
    receiveDailyUpdate,
    isSampleRetainMetadata,
  }) {
    this.userEmail = userEmail;
    this.receiveEmailNotifications = receiveEmailNotifications;
    this.showWorkRequestWidget = showWorkRequestWidget;
    this.showRecentSamplesWidget = showRecentSamplesWidget;
    this.showRecentTestsWidget = showRecentTestsWidget;
    this.showRecentBlendsWidget = showRecentBlendsWidget;
    this.receiveDailyUpdate = receiveDailyUpdate;
    this.isSampleRetainMetadata = isSampleRetainMetadata;
    this.lastLogin = lastLogin;
    this.homeSiteName = homeSiteName;
    this.homeSite = homeSite;
    this.memberProjects = memberProjects;
  }

  static async getMyApplicationPreferences() {
    const api = await API();
    const { data } = await api.get(`/applicationPreference/me`);
    if (data.result) {
      return new ApplicationPreference(data.result);
    } else {
      return new ApplicationPreference();
    }
  }

  static async getByEmail(userEmail) {
    const api = await API();
    const { data } = await api.get(`/applicationPreference/${userEmail}`);
    if (data.result) {
      return new ApplicationPreference(data.result);
    } else {
      return new ApplicationPreference();
      //return null;
    }
  }

  static async update(userEmail, info) {
    const api = await API();
    const { data } = await api.put(`/applicationPreference/${userEmail}`, info);
    return new ApplicationPreference(data.result);
  }
}
